// Questions shown on the home page and, all answers visible, on /faq
export const faqCategories = [
  {
    id: "general",
    label: "Platform98",
    questions: [
      {
        question: "Qu'est-ce que Platform98 ?",
        answer:
          "Platform98 est une plateforme en ligne qui prend en charge vos démarches administratives et juridiques : création d'entreprise, domiciliation, gestion, protection de marque et formalités diverses. Vous déposez votre demande en ligne, un conseiller s'occupe du reste.",
      },
      {
        question: "Dans quels pays proposez-vous vos services ?",
        answer:
          "Pour le moment, la plupart de nos services sont disponibles au Cameroun.",
      },
      {
        question: "Dois-je me déplacer ?",
        answer:
          "Non. Toutes les étapes se font en ligne : dépôt de la demande, envoi des documents, paiement et suivi. Vous récupérez vos documents officiels depuis votre espace.",
      },
    ],
  },
  {
    id: "account",
    label: "Compte et connexion",
    questions: [
      {
        question: "Faut-il créer un mot de passe ?",
        answer:
          "Non. À chaque connexion, vous recevez un code à usage unique par e-mail ou par SMS. Il suffit de le saisir pour accéder à votre espace. Lors de votre inscription, ce code vous est envoyé à la fois par e-mail et par SMS.",
      },
      {
        question: "Je n'ai pas reçu mon code de connexion, que faire ?",
        answer:
          "Vérifiez vos courriers indésirables et que l'adresse e-mail ou le numéro saisi est correct. Vous pouvez ensuite demander un nouveau code depuis l'écran de connexion.",
      },
      {
        question: "Comment suivre ma demande ?",
        answer:
          "Depuis votre espace, la rubrique « Mes démarches » affiche chaque demande avec son statut. Vous êtes également informé par e-mail des étapes importantes.",
      },
    ],
  },
  {
    id: "payment",
    label: "Paiement",
    questions: [
      {
        question: "Quels moyens de paiement acceptez-vous ?",
        answer:
          "Vous pouvez payer avec MTN Mobile Money, Orange Money ou par carte bancaire (Visa, Mastercard).",
      },
      {
        question: "Comment se déroule un paiement par carte bancaire ?",
        answer:
          "La page sécurisée de notre partenaire de paiement s'ouvre dans un nouvel onglet. Vous y saisissez votre carte, puis votre demande est mise à jour dès la confirmation du paiement. Des frais de paiement par carte peuvent s'ajouter au montant.",
      },
      {
        question: "Comment se déroule un paiement Mobile Money ?",
        answer:
          "Vous indiquez votre numéro de téléphone, puis vous recevez une demande de validation sur votre téléphone. Vous confirmez avec votre code secret Mobile Money, directement sur votre téléphone. Votre demande est mise à jour dès la confirmation du paiement.",
      },
      {
        question: "Platform98 peut-il me demander mon code Mobile Money ?",
        answer:
          "Jamais. Platform98 ne vous demandera jamais votre code secret, votre code de connexion ni vos coordonnées bancaires par SMS, appel, e-mail ou WhatsApp. Ne répondez pas à ce type de demande.",
      },
    ],
  },
  {
    id: "documents",
    label: "Documents",
    questions: [
      {
        question: "Quels documents dois-je fournir ?",
        answer:
          "La liste dépend de votre démarche et, pour une création d'entreprise, de la forme juridique choisie. Elle vous est présentée au moment de l'envoi des documents, avec une description de chaque pièce.",
      },
      {
        question: "Sous quel format envoyer mes documents ?",
        answer:
          "Nous recommandons le PDF, ou une photo nette au format JPG ou PNG. Chaque fichier doit être lisible dans son intégralité.",
      },
      {
        question: "Mes documents sont-ils en sécurité ?",
        answer:
          "Vos documents sont stockés sur un espace sécurisé. Ils ne sont accessibles qu'à vous et aux conseillers chargés de votre dossier.",
      },
    ],
  },
  {
    id: "delays",
    label: "Délais",
    questions: [
      {
        question: "Combien de temps faut-il pour créer mon entreprise ?",
        answer:
          "Comptez environ 3 jours avec la procédure express et une semaine en moyenne avec la procédure normale, une fois votre dossier complet et payé.",
      },
      {
        question:
          "Comment se déroule la protection du nom commercial à l'OAPI ?",
        answer:
          "La démarche se fait en deux étapes : une recherche d'antériorité d'environ deux semaines, qui vérifie que le nom est disponible, puis le dépôt. Votre nom est protégé dès le dépôt ; la délivrance des documents officiels par l'OAPI prend ensuite 3 à 6 mois.",
      },
      {
        question:
          "Combien de temps pour l'inscription au fichier des importateurs ?",
        answer: "Comptez une semaine en moyenne.",
      },
    ],
  },
  {
    id: "formalities",
    label: "Formalités",
    questions: [
      {
        question: "Quelles formalités puis-je faire en ligne ?",
        answer:
          "Attestation d'immatriculation (NIU), attestation de conformité fiscale, immatriculation à la CNPS, identité visuelle (logo, cartes de visite, plaquettes, cachets), inscription au fichier des importateurs, protection du nom commercial et de la marque à l'OAPI, branchement ENEO, business plan, extrait de casier judiciaire, certificats de nationalité et de célibat, et pré-enrôlement passeport.",
      },
      {
        question: "Puis-je commander à nouveau une formalité déjà faite ?",
        answer:
          "Oui. Une attestation ou un support d'identité visuelle peut être commandé de nouveau à tout moment, par exemple une attestation de conformité fiscale chaque mois.",
      },
      {
        question: "Où trouver le prix d'une formalité ?",
        answer:
          "Le prix est affiché sur chaque formalité, dans la page des formalités, avant toute commande. Vous ne payez qu'après avoir vérifié le récapitulatif.",
      },
    ],
  },
];
